import styled, { CSSProperties, keyframes } from 'styled-components'

interface StyledDropzoneProps {
  center?: string,
  [prop: string]: any
  $maxWidthDropZone?: CSSProperties['width']
}

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

export const StyledDropzone = styled.section<StyledDropzoneProps>`
width: 100%;
max-width: ${props => props?.$maxWidthDropZone ?? '250px'};
min-height: 140px;
border-width: 1px;
display: flex;
align-items: center;
justify-content: center;
cursor: pointer;
border-color: rgba(34,36,38,.15);
border-style: dashed;
border-width: 2px;
border-radius: 5px;
padding: 10px;
position: relative;
animation: ${fadeInUp} 0.3s ease forwards;

&:hover {
  border-color: #85b7d9 !important;
}

.uploadContainer {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 5px;
  font-weight: bold;
  i {
    color: #3194d8;
    font-size: 50px;
 }
}


&.group-excluded {
  color: rgba(122, 122, 30, .9);
  background-color: rgba(255, 255, 122, .1);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 80px;
}

> p {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  text-align: center;
}
`

export const StyledUploadZone = styled.div`
  width: 150px;
  height: 150px;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: linear-gradient(145deg, #f8f9fa, #e9ecef);

  &:hover {
    border-color: ${props => props.theme.firstColor || '#2185d0'};
    background: linear-gradient(145deg, #e9ecef, #dee2e6);
    transform: scale(1.02);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);

    .upload-icon {
      transform: translateY(-3px);
    }
  }

  .upload-icon {
    font-size: 36px !important;
    color: ${props => props.theme.firstColor || '#2185d0'} !important;
    margin-bottom: 8px !important;
    transition: transform 0.3s ease;
  }

  .upload-text {
    font-size: 12px;
    color: #666;
    text-align: center;
    padding: 0 10px;
  }
`
